import { Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';

export function parseTags(field: Field | Item | Item[] | undefined): string[] | null {
	let tags: string[] | null = [];
	try {
		(field as Item[]).map((tag) => tags?.push((tag?.fields?.Title as Field<string>).value));
	} catch (error) {
		console.error(error);
		tags = null;
	}

	return tags;
}
